import { TextCell, TextCellProps } from './TextCell';

type NumberFormatStyles = 'decimal' | 'percent' | 'currency';
export interface NumberFormatProps {
    fractionDigits?: number;
    style?: NumberFormatStyles;
}

export const NumberCell = (props: TextCellProps & NumberFormatProps) => {
    const { fractionDigits = 2, style = 'decimal', textAlign = 'right', value, ...rest } = props;

    const formatter = new Intl.NumberFormat('en-US', {
        style,
        currency: style === 'currency' ? 'USD' : undefined,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });

    return (
        <TextCell textAlign={textAlign} value={value !== undefined ? formatter.format(Number(value)) : ''} {...rest} />
    );
};
